import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* REST API */
import { credit } from "../../api/Electron"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"

/* Sweet alert */
import Swal from "../../helpers/alert"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"
import { CloseIcon } from "../../components/Icons"


/* Widget ElectronPayment — the refund and the payment of a round, opened from the round card */
class ElectronPayment extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            type: "",
            amount: "",
            waiting: false,

            data: null,
            balance: null,
            gameProcess: [],
            currency: "USD",
        }
    }

    /* Open Action */
    open = ({ type, data, balance, gameProcess, currency }) => {
        this.setState({ visible: true, type, amount: "", data, balance, gameProcess: gameProcess || [], currency: currency || "USD" })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, type: "", amount: "" })
    }

    /* Send Action */
    send = () => {

        /* Fields */
        const { amount, type, data, currency } = this.state
        const { uid, game, socket, apply } = this.props

        /* Check Amount */
        if (amount === null || amount === undefined || amount === "" || parseFloat(amount) === 0) {
            Swal.fire(utils.notification(t("widget.amountError"), "error"))
            return
        }

        Swal.fire({
            title: t("widget.operationConfirm"),
            text: t("widget.finishWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196f3",
            reverseButtons: true,
            confirmButtonText: t("widget.finishButton"),
            cancelButtonText: t("common.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {

                this.setState({ waiting: true })

                /* SEND TO REST API */
                credit(game.key, { uid, type, refund: amount, currency, playerID: data.player, roundId: data.roundId, id: data.id }).then((response) => {
                    if (response.status === 200) {

                        if (socket) {
                            if (type === "refund") {
                                socket.emit("adminNotification", { type: "refund", title: "Return of funds", total: amount, currency, playerID: data.player, gameID: data.id })
                            }
                            else {
                                socket.emit("adminNotification", { type: "payment", title: "Replenishment of the amount", total: amount, currency, playerID: data.player, gameID: data.id })
                            }
                        }

                        Swal.fire(utils.notification(type === "refund" ? t("widget.refundSuccess") : t("widget.paySuccess"), "success"))

                    }
                    else {
                        Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("widget.somethingWrong"), "error"))
                }).finally(() => {
                    this.setState({ waiting: false, type: "", visible: false, amount: "" })
                    if (apply) {
                        apply()
                    }
                })
            }
        })

    }


    render = () => {

        /* Fields */
        const { visible, type, amount, waiting, data, balance, gameProcess } = this.state

        /* Check Data */
        if (!data) {
            return null
        }

        /* The ante of the round feeds the payment form */
        const index = gameProcess.findIndex((process) => process.type === "ante")

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="refund--modal"
                overlayClassName="refund--overlay"
                closeTimeoutMS={200}
            >

                <div className="refund--modal-header">
                    <h2>{type === "refund" ? t("widget.refundTitle") : t("widget.payTitle")}</h2>
                    <div onClick={() => this.close()} className="refund--modal-close">
                        <CloseIcon size={16} />
                    </div>
                </div>

                <div className="refund--modal-content">

                    {type === "refund" &&
                        <div className="refund--modal-information">
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">{t("widget.totalBet")}</div>
                                <div className="refund--modal-information-name">{balance ? balance.debit : "-"}</div>
                            </div>
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">{t("widget.refunded")}</div>
                                <div className="refund--modal-information-name">{utils.convertor(data.refund ? parseFloat(data.refund) : 0, data.symbol)}</div>
                            </div>
                        </div>
                    }

                    {type === "payment" &&
                        <div className="refund--modal-information">
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">ANTE</div>
                                <div className="refund--modal-information-name">{index > -1 ? utils.convertor(gameProcess[index].total, data.symbol) : "-"}</div>
                            </div>
                            <div className="refund--modal-information-item">
                                <div className="refund--modal-information-text">{t("widget.paid")}</div>
                                <div className="refund--modal-information-name">{utils.convertor(data.paid ? parseFloat(data.paid) : 0, data.symbol)}</div>
                            </div>
                        </div>
                    }

                    <input placeholder={t("widget.amountError")} type="text" value={amount} onChange={(event) => this.setState({ amount: event.target.value.replace(/\D/g, "") })} />

                    {waiting
                        ? <div className="refund--modal-button disabled"><LoadingOutlined /></div>
                        : <div className="refund--modal-button" onClick={() => this.send()}>{t("widget.pay")}</div>
                    }

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(ElectronPayment)
